module.exports = __webpack_public_path__ + "img/logo.e40b4eb8.svg";